// extracted by mini-css-extract-plugin
export default {"nodata":"NoData_nodata__qFk9S"};